import { BinaryWriter, ProtocolError } from "../binary.js";
import { ClientOp } from "../opcodes.js";
import { isDirection } from "../constants.js";
export function encodeMove(packet, writer = new BinaryWriter(8)) {
    writer.u8(ClientOp.Move).u8(packet.direction).u32(packet.seq);
    return writer;
}
export function decodeMove(reader) {
    const direction = reader.u8();
    const seq = reader.u32();
    // Vem da rede: nada garante que seja uma direção válida antes de checar.
    if (!isDirection(direction)) {
        throw new ProtocolError(`direção inválida: ${direction}`);
    }
    return { direction, seq };
}
//# sourceMappingURL=move.js.map